import { Box, Text, Input, FormControl, Flex, Spacer } from "@chakra-ui/react";
import { FaRegTrashAlt } from "react-icons/fa";

interface CardRegraProps {
  onDelete: () => any;
  tituloCard: string;
  temValor: boolean;
  onChange: (value?: any) => any;
  valor: string;
  isInvalid?: boolean;
}

function CardRegra({
  onDelete,
  tituloCard,
  temValor,
  onChange,
  valor,
  isInvalid,
}: CardRegraProps) {
  return (
    <Box>
      <Flex>
        <Text fontSize="12px" fontWeight="400" fontFamily="Poppins">
          {tituloCard}
        </Text>
        <Spacer />
        <FaRegTrashAlt
          fontSize="16px"
          color="#bababa"
          onClick={onDelete}
          cursor="pointer"
        />
      </Flex>
      {temValor ? (
        <Flex mt="11px">
          <FormControl>
            <Input
              size="sm"
              w="100px"
              type="number"
              placeholder="0"
              style={{
                textAlign: "left",
              }}
              isInvalid={isInvalid}
              onChange={onChange}
              value={valor}
            />
          </FormControl>
        </Flex>
      ) : null}
    </Box>
  );
}

export default CardRegra;
